module.exports = __webpack_public_path__ + "static/img/noDate.7f02f6d2.png";